import React, { useEffect, useState } from 'react'
import { Accordion, Card } from 'react-bootstrap';
import { BaseUrl } from '../helper/BaseUrl';
import { useLocation, useParams } from 'react-router-dom';

export default function GlobalFaq() {
  const [activeKey, setActiveKey] = useState("0");
  const [data, setData] = useState(null);
  const location = useLocation();
  const { slug } = useParams();

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  useEffect(() => {
    const controller = new AbortController();

    const fetchFaq = async () => {
      try {
        setData(null);

        const response = await fetch(
          `${BaseUrl}/api/faq-by-url/${slug}`,
          {
            method: "GET",
            signal: controller.signal,
          }
        );

        const result = await response.json();

        if (!response.ok || result.error) {
          throw new Error(result.message || "Unable to fetch FAQ data.");
        }

        setData(result.data || []);
        setActiveKey("0");
      } catch (error) {
        if (error.name !== "AbortError") {
          setData(null);
          console.error("FAQ fetch error:", error.message);
        }
      }
    };

    fetchFaq();

    return () => controller.abort();
  }, [location.pathname]);

  return (
    <>
      {data?.length > 0 && (
        <div className="global-faq-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="text-center">
                  <h4 className="heading">Frequently Asked Questions</h4>
                </div>

                <Accordion activeKey={activeKey} className="globalfaq-accord">
                  {data?.map((faq, index) => {
                    const key = index.toString();
                    return (
                      <Card key={faq?._id || index} className={`accordion-items ${activeKey === key ? "active" : ""}`}>
                        <Card.Header>
                          <Accordion.Item eventKey={key}>
                            <Accordion.Header as="div" onClick={() => handleToggle(key)}>
                              <label>{faq?.question}</label>
                              <span>{activeKey === `${index}` ? "−" : "+"}</span>
                            </Accordion.Header>

                            <Accordion.Body>
                              <p>{faq?.answer}</p>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Card.Header>
                      </Card>
                    );
                  })}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      )} 
    </>
  )
}
